<template>
  <div class="app-container">
    <el-button
      size="medium"
      type="primary"
      @click="addMenu(0)"
      v-if="roles.includes('/menu/add')"
      >添加顶级菜单</el-button
    >
    <el-button
      size="medium"
      type="danger"
      @click="delMenu()"
      v-if="roles.includes('/menu/batch_del')"
      >删除菜单</el-button
    >
    <el-table
      max-height="700"
      v-loading="listLoading"
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column label="序号" width="150">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column label="菜单排序" width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.sort }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="所属模块" width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.xcx_mode == 1 ? "企业模块" : "住宅模块" }}
        </template>
      </el-table-column> -->
      <el-table-column label="菜单名称">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.title }}</div>
        </template>
      </el-table-column>
      <el-table-column label="菜单图标" width="110" align="center">
        <template slot-scope="scope">
          <img
            v-if="scope.row.icon"
            class="tableIcon"
            alt=""
            srcset=""
            :src="imageOss + scope.row.icon"
          />
        </template>
      </el-table-column>
      <el-table-column label="路由地址" width="110" align="center">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.router_url }}</div>
        </template>
      </el-table-column>
      <el-table-column label="前端路由" width="110" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.url }}</span>
        </template>
      </el-table-column>
      <el-table-column label="菜单形式" width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.type == 1 ? "菜单" : "按钮" }}
        </template>
      </el-table-column>
      <el-table-column label="菜单类型" width="110" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.menu_type == 1 ? "后台 " : "小程序" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="备注" width="110" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.remark }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column class-name="status-col" label="Status" width="110" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status | statusFilter">{{ scope.row.status }}</el-tag>
        </template>
      </el-table-column> -->
      <el-table-column
        align="center"
        prop="created_at"
        label="操作"
        width="300"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            v-if="roles.includes('/menu/add')"
            @click="addMenu(scope.row.id)"
            >添加</el-button
          >
          <el-button
            size="mini"
            type="warning"
            v-if="roles.includes('/menu/info')"
            @click="handleSee(scope.row)"
            >查看</el-button
          >
          <el-button
            size="mini"
            type="success"
            v-if="roles.includes('/menu/edit')"
            @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            v-if="roles.includes('/menu/del')"
            @click="handleDelete(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-drawer
      size="600px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
      @close="dialogClos"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="菜单名称" prop="title">
          <el-input
            v-model="ruleForm.title"
            :disabled="cztype == 'see'"
            placeholder="请输入菜单名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="菜单形式" prop="type">
          <el-radio-group v-model="ruleForm.type" :disabled="cztype == 'see'">
            <el-radio :label="1">菜单</el-radio>
            <el-radio :label="2">按钮</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="所属模块" prop="xcx_mode">
          <el-radio-group
            v-model="ruleForm.xcx_mode"
            :disabled="cztype == 'see'"
          >
            <el-radio :label="1">企业模块</el-radio>
            <el-radio :label="2">住宅模块</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <!-- <el-form-item label="菜单类型" prop="menu_type">
          <el-radio-group v-model="ruleForm.menu_type" :disabled="cztype == 'see'">
            <el-radio :label="1">后台</el-radio>
            <el-radio :label="2">小程序</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="菜单图标" prop="icon">
          <el-upload
            :limit="1"
            name="file[]"
            :data="{ type: 'mini_base_image' }"
            ref="upload"
            :action="ossUpload"
            :file-list="fileList"
            :headers="{ token: token }"
            list-type="picture-card"
            :on-remove="handleRemove"
            :on-success="handleAvatarSuccess"
            :disabled="cztype == 'see'"
            :before-upload="beforeAvatarUpload"
            accept=".png,.svg"
            :class="fileList.length > 0 ? 'hide' : ''"
          >
            <i class="el-icon-plus"></i> </el-upload
          ><!-- 已修改 -->
        </el-form-item>
        <el-form-item label="切换图标" prop="icon_change">
          <el-upload
            :limit="1"
            name="file[]"
            :data="{ type: 'mini_base_image' }"
            ref="upload1"
            :action="ossUpload"
            :file-list="fileList1"
            :headers="{ token: token }"
            list-type="picture-card"
            :on-remove="handleRemove1"
            :on-success="handleAvatarSuccess1"
            :disabled="cztype == 'see'"
            :before-upload="beforeAvatarUpload"
            accept=".png,.svg"
            :class="fileList1.length > 0 ? 'hide' : ''"
          >
            <i class="el-icon-plus"></i> </el-upload
          ><!-- 已修改 -->
        </el-form-item>
        <el-form-item label="路由地址" prop="router_url">
          <el-input
            v-model="ruleForm.router_url"
            :disabled="cztype == 'see'"
            placeholder="请输入路由地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="前端路由" prop="url">
          <el-input
            v-model="ruleForm.url"
            :disabled="cztype == 'see'"
            placeholder="请输入前端路由地址"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="链接参数" prop="params" v-if="cztype != 'see'">
          <el-input v-model="ruleForm.params" :disabled="cztype == 'see'" placeholder="请输入链接参数"></el-input>
        </el-form-item> -->
        <el-form-item label="	状态" prop="status">
          <el-radio-group v-model="ruleForm.status" :disabled="cztype == 'see'">
            <el-radio :label="0">禁用</el-radio>
            <el-radio :label="1">启用</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="链接打开方式" prop="target">
          <el-radio-group v-model="ruleForm.target" :disabled="cztype == 'see'">
            <el-radio :label="1">新页面</el-radio>
            <el-radio :label="2">当前页面</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="菜单排序" prop="sort">
          <el-input
            v-model="ruleForm.sort"
            :disabled="cztype == 'see'"
            placeholder="请输入菜单排序"
            type="number"
            class="numInput"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            v-model="ruleForm.remark"
            :disabled="cztype == 'see'"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="cztype == 'add'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            立即创建
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button>
          <el-button
            v-if="cztype == 'add'"
            type="info"
            @click="resetForm('ruleForm')"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  miniMenu,
  addMiniMenu,
  editMiniMenu,
  delMenu,
  delImage,
  infoMiniMenu,
} from "@/api/index";
import { getToken } from "@/utils/auth";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  data() {
    return {
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加菜单",
      token: getToken(),
      ruleForm: {
        pid: "",
        title: "",
        type: 1,
        menu_type: 2,
        icon: "",
        icon_change: "",
        router_url: "",
        url: "",
        params: "",
        status: 1,
        target: 2,
        sort: "",
        remark: "",
      },
      rules: {
        title: [{ required: true, message: "请输入菜单名称", trigger: "blur" }],
        type: [
          { required: true, message: "请选择菜单形式", trigger: "change" },
        ],
        menu_type: [
          { required: true, message: "请选择菜单类型", trigger: "change" },
        ],
      },
      multipleSelection: [],
      cztype: "",
      ossUpload: this.$store.state.ossUpload,
      oldImg: "",
      oldImg1: "",
      fileList: [],
      fileList1: [],
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    dialogClos() {
      this.fileList = [];
      this.fileList1 = [];
      this.$refs.upload.clearFiles();
      this.$refs.upload1.clearFiles();
    },
    handleRemove(file) {
      this.fileList = [];
      this.ruleForm.icon = "";
    },
    handleRemove1(file) {
      this.fileList1 = [];
      this.ruleForm.icon_change = "";
    },
    handleAvatarSuccess1(res, file) {
      if (res.code === 200) {
        if (this.ruleForm.icon_change) {
          this.delImg(this.ruleForm.icon_change);
        }
        this.fileList1.push({ url: this.imageOss + res.data.url[0] });
        this.ruleForm.icon_change = res.data.url[0];
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.fileList = list;
      }
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    handleAvatarSuccess(res, file) {
      if (res.code === 200) {
        if (this.ruleForm.icon) {
          this.delImg(this.ruleForm.icon);
        }
        this.fileList.push({ url: this.imageOss + res.data.url[0] });
        this.ruleForm.icon = res.data.url[0];
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url[0],
              response: {
                data: {
                  url: item.response.data.url[0],
                },
              },
            });
          }
        });
        this.fileList = list;
      }
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    delImg(path) {
      if (path) {
        delImage({ file: path }).then((ress) => {});
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      // if (!isJPG) {
      //   this.$message.error("上传图片只能是 PNG 格式!");
      // }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return  isLt2M;
    },
    // 修改
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then((_) => {
              console.log(that.ruleForm,'腹股沟管过过')
              editMiniMenu(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  if (this.oldImg != that.ruleForm.icon) {
                    that.delImg(this.oldImg);
                  }
                  if (this.oldImg1 != that.ruleForm.icon_change) {
                    that.delImg(this.oldImg1);
                  }
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch((_) => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 编辑
    handleEdit(val) {
      this.cztype = "edit";
      this.drawerTitle = "编辑";
      // this.ruleForm = JSON.parse(JSON.stringify(val));
      this.getInfo(val.id);
      this.oldImg = val.icon;
      this.drawer = true;
    },
    // 查看
    handleSee(val) {
      this.cztype = "see";
      this.drawerTitle = "查看";
      this.getInfo(val.id);
      // this.ruleForm = val;
      this.drawer = true;
    },
    getInfo(id) {
      infoMiniMenu({ id: id }).then((res) => {
        this.ruleForm = {
          id: res.data.info.id,
          pid: res.data.info.pid,
          title: res.data.info.title,
          type: res.data.info.type,
          menu_type: res.data.info.menu_type,
          icon: res.data.info.icon,
          icon_change: res.data.info.icon_change,
          router_url: res.data.info.router_url,
          url: res.data.info.url,
          params: res.data.info.params,
          status: res.data.info.status,
          target: res.data.info.target,
          sort: res.data.info.sort,
          remark: res.data.info.remark,
          // xcx_mode: res.data.info.xcx_mode,
        };

        this.oldImg = res.data.info.icon;
        this.oldImg1 = res.data.info.icon_change;
        this.fileList = [];
        if (res.data.info.icon) {
          this.fileList.push({ url: this.imageOss + res.data.info.icon });
        }
        this.fileList1 = [];
        if (res.data.info.icon_change) {
          this.fileList1.push({
            url: this.imageOss + res.data.info.icon_change,
          });
        }
      });
    },
    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then((_) => {
          delMenu({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch((_) => {});
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              addMiniMenu(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          done();
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
        })
        .catch(() => {});
    },
    addMenu(id) {
      this.drawerTitle = "添加菜单";
      this.cztype = "add";
      this.drawer = true;
      this.ruleForm = {
        pid: id,
        title: "",
        type: 1,
        menu_type: 2,
        icon: "",
        icon_change: "",
        router_url: "",
        url: "",
        params: "",
        status: 1,
        target: 2,
        sort: 0,
        remark: "",
        // xcx_mode: 1,
      };
    },
    delMenu() {
      var that = this;
      var ids = [];
      if (this.multipleSelection.length) {
        this.multipleSelection.forEach((item, index) => {
          ids.push(item.id);
        });
      } else {
        this.$message.error("至少选择一个菜单");
        return;
      }
      this.$confirm("确认删除？")
        .then(() => {
          delMenu({ id: ids.toString(",") }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
    },
    fetchData() {
      this.listLoading = true;
      var date = {
        is_page: 2,
        page: 1,
        page_size: 15,
        menu_type: 2,
        is_tree: 2,
      };
      miniMenu(date).then((response) => {
        this.list = response.data;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}

.table-box {
  margin-top: 20px;
}
.avatar-uploader {
  width: 60px;
  height: 60px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 70px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
//去除动画
::v-deep .el-list-enter-active,
::v-deep .el-list-leave-active {
  transition: all 0s;
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
</style>
